import { City } from "./City.model";

export class Church {
    id: number;
    name: string;
    address: string;
    phone: string;
    email: string;
    latitude: string;
    length: string;
    church_type: string;
    image_path: string;
    /* city: {
        id: number
        name: string
        code: string
        sectional: {
            id: number
            name: string
            description: string
            district: {
                id: number
                name: string
                description: string
            }
        }
    }; */
    city: City;
    city_id: number;

    constructor() {
        this.name = null;
        this.address = null;
        this.phone = null;
        this.email = null;
        this.latitude = null;
        this.length = null;
        this.church_type = null;
        this.city = new City();
        this.image_path = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/church.model.ts